export function debounce<T extends unknown[]>(callback: (...args: T) => void, wait: number) {
  let timer: NodeJS.Timeout | number;

  return (...args: T): void => {
    clearTimeout(timer as number);
    timer = setTimeout(() => {
      callback(...args);
    }, wait);
  };
}
